/**
 * Adzuki.status_mesage
 */

(function StatusMessage($, Adzuki)
{
	"use strict";

	var message = function show(type, message, title, opts) {
		var icon,
		    class_type,
		    _title,
		    _type = type || '',
		    _opts = $.extend({}, opts);

		switch (_type.toLowerCase()) {
			case 'warning':
				icon       = Adzuki.Icons.warning.class;
				class_type = 'warning';
				_title     = 'Proceed with Caution';
				break;
			case 'error':
				icon       = Adzuki.Icons.warning.class;
				class_type = 'error';
				_title     = 'Error';
				break;
			case 'info':
				icon       = Adzuki.Icons.info.class;
				class_type = 'confirm';
				_title     = 'Updated';
				break;
			case 'success':
				icon       = Adzuki.Icons.success.class;
				class_type = 'success';
				_title     = 'Success';
				break;
			default:
				icon       = Adzuki.Icons.info_circle.class;
				class_type = 'confirm';
				_title     = 'Decision Time';
				break;
		}

		if (title !== undefined) {
			_title = title;
		}


		return $.alert({
			// uncommon jconfirm options
			animation              : 'opacity',
			animateFromElement     : false,
			scrollToPreviousElement: false,
			backgroundDismiss      : _opts.bg_dismiss || true,
			theme                  : 'bootstrap',

			// common options
			title       : _title,
			content     : message,
			icon        : _opts.icon || 'fa ' + icon,
			columnClass : _opts.column_class || jconfirm.pluginDefaults.columnClass,
			onOpenBefore: function applyStatusClass() {
				this.$body.addClass('adzuki-status ' + class_type);
			},
			onClose: function onClose() {
				if (typeof _opts.onClose === 'function') {
					_opts.onClose();
				}
			}
		});
	};

	Adzuki.StatusMessage = message;
}(jQuery, window.Adzuki || {}));
